import PIPELINE_STEPS from '../../../../utils/pipeline_steps';
import TableModel from '../../../datasource/table';
import ColumnActionModel from './column_action_model';

export default class RenameColumnStepModel extends ColumnActionModel {
    name = 'Rename Column';
    type = PIPELINE_STEPS.RENAME_COLUMN;
    newName = '';

    constructor({newName, ...otherProps} = {}) {
        super(otherProps);
        this.newName = newName || '';
    }

    apply(table) {
        const origColumn = table.getColumnById(this.columnId);
        if (!origColumn) {
            return {table, error: true}
        }
        if (!this.newName) {
            return {before: origColumn.label, after: origColumn.label, table, incomplete: true};
        }
        table = new TableModel(table);
        const newColumn = table.getColumnById(this.columnId);
        newColumn.label = this.newName;
        return {before: origColumn.label, after: this.newName, table};
    }
}
